import { render, staticRenderFns } from "./MobilePager.vue?vue&type=template&id=7206fe4b&scoped=true"
import script from "./MobilePager.vue?vue&type=script&lang=js"
export * from "./MobilePager.vue?vue&type=script&lang=js"
import style0 from "./MobilePager.vue?vue&type=style&index=0&id=7206fe4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206fe4b",
  null
  
)

export default component.exports